import React from "react";
import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export default function Testimonial() {
    return (
        <section
            data-testid="testimonial-section"
            className="relative bg-obsidian-800 py-28 md:py-40 border-y border-white/10"
        >
            <div className="max-w-[1200px] mx-auto px-6 md:px-10 lg:px-16">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, ease }}
                    className="grid grid-cols-12 gap-8"
                >
                    <div className="col-span-12 md:col-span-2 flex items-start">
                        <span className="font-serif-display italic text-amber-glow text-7xl leading-none">
                            &ldquo;
                        </span>
                    </div>
                    <div className="col-span-12 md:col-span-10">
                        <blockquote className="font-serif-display italic text-3xl md:text-5xl leading-[1.15] tracking-tight text-ice-50">
                            The missing ingredient in a world-class cocktail is never more gin. It is better ice.
                        </blockquote>
                        <div className="mt-10 flex items-center gap-4">
                            <span className="h-px w-10 bg-amber-glow" />
                            <div>
                                <span className="block text-ice-50 text-sm">Elena Marchetti</span>
                                <span className="block text-[0.68rem] uppercase tracking-[0.3em] text-ice-400 mt-1">
                                    Head Sommelier · Sommelier Magazine
                                </span>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
